import { from, Observable, of } from "rxjs";
import { ApplyEventStrategy, Command, CommandContext, CommandPage } from "controls";
import { RequestRoot } from "types";
import { concatMap } from "rxjs/operators";

export class ReadyCommand implements Command<RequestRoot> {
    constructor(private date: Observable<Date>) {
    }

    icon(): string {
        return '';
    }

    caption(): string {
        return 'command.request.ready';
    }

    color(): boolean {
        return false;
    }

    visible(ctx: CommandContext, selection: RequestRoot[], all: RequestRoot[]): boolean {
        return true;
    }

    enabled(ctx: CommandContext, selection: RequestRoot[]): boolean {
        return true;
    }

    execute(ctx: CommandContext, page: CommandPage, requests: RequestRoot[]): Observable<RequestRoot> {
        return from(requests).pipe(
            concatMap(x => ctx.validateRequest(page, x, this.date, true)),
            concatMap(x => ctx.applyRequestStatus(x.request, x.good ? 'READY' : 'DATA_ENTERED')),
            concatMap(x => ctx.removeRequestEvent(x, 'READY')),
            concatMap(x => ctx.applyRequestEvent(page, x, 'DATA_ENTERED', this.date, ApplyEventStrategy.ReplaceLastIfMultiple)),
            concatMap(x => x.status === 'READY' ? ctx.applyRequestEvent(page, x, 'READY', this.date, ApplyEventStrategy.ReplaceLastIfMultiple) : of(x)),
        ).pipe(
            concatMap(x => ctx.saveRequest(page, x)),
            concatMap(x => ctx.undirtyRequest(page, x)),
            concatMap(x => x.status === 'READY' ? ctx.confirmRequestsAction(page, [x], 'fail.request.sitesucc', false) : of(x)),
            concatMap(x => x.status === 'READY' ? ctx.closeRequestWizard(page, false) : from([]))
        );
    }
}
